/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget useful link component styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../../../theme';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import { WidgetSkeletonParagraphNormalStyled } from '../../styled/WidgetSkeletonStyled';

export const WidgetUsefulStyled = styled(WidgetBlockStyled)`
    .widget-useful__title {
        ${fonts.textHeader3};
    }

    .widget-useful__link-container {
        display: inline-flex;
        flex-direction: column;
    }

    .widget-useful__link {
        width: fit-content;
        margin-bottom: 12px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    ${WidgetSkeletonParagraphNormalStyled} {
        margin-bottom: 12px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;
